const einDashboard = {
  einDashboard: {
    installingSince: 'Instalando o Enphase desde',
    accountManager: 'Gerente de contas da Enphase',
    installationShare: 'Compartilhamento de instalações da Enphase',
    nps: 'Pontuação do promotor líquido',
    viewDashboard: 'Exibir painel',
    quarterInfo: 'a partir do T%{quarter},%{year} (Residencial)',
    npsTooltip: 'A pontuação do promotor líquido é um índice de -100 a 100 que mede a disposição dos clientes em recomendar os produtos ou serviços de uma empresa a terceiros. Essa pontuação é baseada nas classificações dadas por seus clientes no aplicativo de celular do Enlighten para seus serviços e só é visível para você e a Enphase. O período padrão para os dados são os últimos 13 meses.',
    activity: 'Atividade',
    sites: 'Unidades solares',
    batteries: 'Baterias',
    acb: 'ACB',
    certifications: 'Certificações',
    community: 'Comunidade',
    storage: 'Unidades de armazenamento',
    lastInstalledLabel: 'instalado nos últimos 12 meses',
    lastCommissionedLabel: 'comissionado nos últimos 12 meses',
    viewDetails: 'Ver detalhes',
    seeReviews: 'Ver comentários',
    viewCommunity: 'Ver comunidade',
    certificateLabel: '%{count}fora das %{totalCount} certificações concluídas',
    networkLabel: { 
      one: '%{count} postagem, última postagem %{postDate}',
      other: '%{count} postagens, última postagem %{postDate}'
    },
    requestProductAccess: 'Solicitar acesso ao produto',
    inverter: 'IQ-8',
    ensemble: 'Conjunto 2.0',
    permit: 'Permissão de assistência',
    sgip: 'Assistência SGIP',
    learnMore: 'Saiba mais',
    aboutProduct: 'sobre o produto',
    betaReleaseDate: 'Data de lançamento beta',
    requestEarlyAccess: 'Solicitar acesso antecipado',
    viewAllProduct: 'Ver todos os produtos',
    signUp: 'Me inscreva',
    betaReleaseLabel: 'para todos os novos lançamentos de produtos beta',
    financing: 'Apoio de financiamento',
    digitalPlatform: 'Plataforma digital',
    lpp: 'LPP',
    requestedText: 'Pedido enviado para acesso antecipado',
    grantedText: 'Acesso beta concedido',
    products: 'Produtos',
    ratingsReviews: 'Classificações e avaliações',
    reviews: 'Avaliações',
    otherReviews: 'Outras avaliações',
    updateDetails: 'Detalhes de atualização',
    totalSavings: 'Poupança total',
    inLastYear: 'nos últimos 12 meses',
    viewBreakdown: 'Ver análise detalhada',
    leadsReceived: 'Leads recebidos',
    leadsClosure: 'Encerramento de Leads',
    leadsWon: 'Leads ganhos',
    creditAvailable: 'Crédito disponível',
    buyMore: 'Comprar mais',
    messageFromCeo: 'Mensagem do nosso CEO',
    communityUpdates: 'Atualizações da comunidade',
    makeAppointments: 'Marcar consultas',
    applicableText: 'Aplicável apenas para membros Platina',
    view: 'Visualizar',
    downloadAll: 'Baixar tudo',
    promoteText: 'Promova sua empresa com emblemas e logotipos',
    asOfText: 'A partir de %{date}',
    yearTotal: 'Total/ano',
    redeemed: 'Resgatada',
    laborProtectionPlan: 'Programa de proteção ao trabalho',
    acmPromotion: 'Promoção ACM',
    save: {
      lre_data: 'Poupança de LPP',
      permit_data: 'Poupança da licença',
      financing_data: 'Poupança de Financiamento',
      sgip_data: 'Poupança de SGIP',
      warrantyExtension: 'Economia na extensão da garantia'
    },
    platinumLogo: 'Logotipo Platina',
    enphaseLogo: 'Logotipo da Enphase',
    otherAssets: 'Outros ativos',
    ensembleCertificate: 'Conjunto certificado',
    salesCertificate: 'Certificado de vendas 1.0',
    marketingCertificate: 'Certificada em Marketing 1.0',
    solarInstallCertificate: 'Certificado de instalação solar',
    validTill: 'Válida até: %{date}',
    noDataAvailable: 'Sem dados disponíveis',
    notAvailable: 'Não disponível',
    notApplicable: 'Não aplicável',
    title: 'Painel EIN',
    congratulationSignUp: 'Parabéns! Agora você terá acesso antecipado a todos os novos produtos/serviços da Enphase',
    benefits: 'Benefícios',
    installationShareTooltip: 'Este número indica qual porcentagem de suas instalações gerais foram instalações Enphase',
    dataFromThirdParty: '*De acordo com os dados de fonte de terceiros',
    reviewsNotAvailable: 'Comentários não disponíveis',
    enphaseExecutive: 'Executivo da Enphase',
    digitalAssets: 'Ativos digitais',
    leads: 'Leads',
    tierSavings: 'Nível economia',
    exclusiveUpdates: 'Atualizações exclusivas',
    executiveSponsor: 'Patrocinador executivo',
    merchandise: 'Mercadoria',
    certifiedUsers: 'Usuários certificados',
    noteAllowedOnce: 'Nota: o link acima não pode ser editado depois de criado',
    saveLink: 'Salvar link',
    confirm: 'Confirme',
    copyLink: 'Adicionar link',
    allowedCharactersError: 'São permitidos apenas letras, números, hífen e sublinhado (máx. 500 caracteres)',
    createSystemEstimatorLink: 'Crie seu link de Estimador de Sistema personalizado e compartilhe-o com seus clientes para obter leads deles. Qualquer lead gerado a partir deste link será compartilhado apenas com você em seu Enlighten manager.',
    shareSystemEstimatorLink: 'Compartilhe seu link personalizado do Estimador de Sistema com seus clientes para obter leads deles. Qualquer lead gerado a partir deste link será compartilhado apenas com você em seu Enlighten manager.',
    systemEstimatorLink: 'Link do Estimador de Sistema',
    confirmChanges: 'Confirme as alterações',
    confirmSELink: 'Confirme seu link do Estimador de Sistema. Este link não será editável depois de salvo.',
    copied: 'Copiado',
    mySELink: 'Link do meu Estimador de Sistema',
    sdtUrlExistsError: 'Este link já está sendo usado por outra instaladora. Escolha um link diferente',
    all: 'Todos',
    filterText: 'Filtro',
    noProductAvailable: 'Nenhum produto disponível'
  }
};

export default einDashboard;